import { ImportCSVFormErrorsProps } from '@components/process-import-csv/src/process-import-csv.type';

export const CsvImportFormErrors = ({ formColumnErrors }: ImportCSVFormErrorsProps) => {
  if (formColumnErrors)
    return (
      <>
        {formColumnErrors?.message && (
          <p
            className='text-red-500 text-sm'
            dangerouslySetInnerHTML={{
              __html: formColumnErrors?.message as string,
            }}
          />
        )}
        {Object.keys(formColumnErrors)
          .filter((key) => formColumnErrors[key as unknown as number]?.field)
          .map((field, idx) => (
            <p className='text-red-500 text-sm' key={`${field}-${idx}`}>
              <span
                dangerouslySetInnerHTML={{
                  __html: formColumnErrors?.[field as unknown as number]?.field?.message as string,
                }}
              />
            </p>
          ))}
      </>
    );
  return null;
};
